import React, { useState, useEffect } from "react";
import Pagination from "../../../../Components/Pagination/Pagination";
import SkeletonLoading from "../../../../Components/Skeleton/SkeletonLoading";
import { AddPatientLeadModel } from "../../../../Services/Models/Order/OrderModel";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type Props = {
    loading: boolean;
    tableData: AddPatientLeadModel[];
    rowsPerPage: number;
    dataLength: number;
    customClass?: string;
    isErrorTable: boolean;
}

function LoaderSkeleton() {
    let loader: any = [];
    for (let index = 0; index < 10; index++) {
        loader.push(
            <tr className={`hoversuccess`} key={"skeletonLoaderTr_" + index}>
                <td className="" key={"skeletonLoadertd1_" + index}>{<SkeletonLoading />}</td>
                <td className="text-start" key={"skeletonLoadertd2_" + index}>{<SkeletonLoading />}</td>
                <td className="text-start" key={"skeletonLoadertd3_" + index}>{<SkeletonLoading />}</td>
                <td className="text-start" key={"skeletonLoadertd3_" + index}>{<SkeletonLoading />}</td>
                <td className="text-start" key={"skeletonLoadertd3_" + index}>{<SkeletonLoading />}</td>
                <td className="text-start" key={"skeletonLoadertd4_" + index}>{<SkeletonLoading />}</td>
                <td className="text-start" key={"skeletonLoadertd4_" + index}>{<SkeletonLoading />}</td>
            </tr>
        );
    }
    return (
        <>
            {loader}
        </>
    )
}

export default function OrderCompleteTable({ tableData, rowsPerPage, loading, dataLength, customClass, isErrorTable, ...args }: Props) {
    const [isPagination, setIsPagination] = useState<boolean>(false);
    const [page, setPage] = useState<number>(1);

    useEffect(() => {
        if (dataLength === 0 || tableData?.length <= rowsPerPage) {
            setIsPagination(false)
        } else {
            setIsPagination(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tableData, page]);

    return (
        <>
            <div className={`order-table-wrap`} key={"orderTableWrap"}>
                <table className={`table ${customClass}`} data-testid="patientListComponent" key={"patientOrderListTable"}>
                    <thead key={"patientOrderListThead"}>
                        <tr key={"tr1"}>
                            {isErrorTable && (
                                <th scope="col" className="text-start" key={"th3"}>
                                    Error
                                </th>
                            )}
                            <th scope="col" className="mt-1" key={"th1"}>
                                Patient
                            </th>
                            {/* <th scope="col" className="text-start" key={"th2"}>
                                Parent
                            </th> */}
                            <th scope="col" className="text-start" key={"th3"}>
                                Parent Details
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {tableData && !loading ? tableData && tableData?.length > 0 ? (
                            tableData?.slice((page - 1) * rowsPerPage, page * rowsPerPage).map((el: any, index: number) => {
                                return (
                                    <>
                                        <tr key={index}>
                                            {isErrorTable && (
                                                <td className="text-start text-error error-column" key={`${index}_6`}>
                                                    {el.error_message.toString().split("with id")[0] === "Patient and lead already exist" ? "Patient already exist" : el.error_message.toString().split("with id")[0] ?? ""}
                                                </td>
                                            )}
                                            <td className={`text-start ${isErrorTable ? "with-error-col-patient" : "without-error-col-patient"}`} key={`${index}_1`}>
                                                <OverlayTrigger delay={{ hide: 450, show: 300 }} overlay={(props) => (<Tooltip {...props}>{el?.patient?.firstname + " " + el?.patient?.lastname}</Tooltip>)} placement="bottom">
                                                    <label className="parent-email">
                                                        {(el?.patient?.firstname ?? "") + " " + (el?.patient?.lastname ?? "")}
                                                    </label>
                                                </OverlayTrigger>
                                            </td>
                                            {/* <td className={`text-start ${isErrorTable ? "with-error-col-parent" : "without-error-col-parent"}`} key={`${index}_2`}>
                                                {el?.patient?.dob ?? ""}
                                            </td> */}
                                            <td className={`text-start ${isErrorTable ? "with-error-col-parent" : "without-error-col-parent"}`} key={`${index}_3`}>
                                                {!isErrorTable ? (
                                                    <>
                                                        <OverlayTrigger delay={{ hide: 450, show: 300 }} overlay={(props) => (<Tooltip {...props}>{(el?.emergencyContact?.ecFirstName ?? "") + " " + (el?.emergencyContact?.ecLastName ?? "")}</Tooltip>)} placement="bottom">
                                                            <label className="parent-email">
                                                                <b>Name</b>: {(el?.emergencyContact?.ecFirstName ?? "") + " " + (el?.emergencyContact?.ecLastName ?? "")}
                                                            </label>
                                                        </OverlayTrigger>
                                                    </>
                                                ) : (
                                                    <>
                                                        <OverlayTrigger delay={{ hide: 450, show: 300 }} overlay={(props) => (<Tooltip {...props}>{(el?.lead?.ecFirstName ?? "") + " " + (el?.lead?.ecLastName ?? "")}</Tooltip>)} placement="bottom">
                                                            <label className="parent-email">
                                                                <b>Name</b>: {(el?.lead?.ecFirstName ?? "") + " " + (el?.lead?.ecLastName ?? "")}
                                                            </label>
                                                        </OverlayTrigger>
                                                    </>
                                                )}
                                                <br />
                                                {!isErrorTable ? (
                                                    <>
                                                        <OverlayTrigger delay={{ hide: 450, show: 300 }} overlay={(props) => (<Tooltip {...props}>{el?.emergencyContact?.ecEmail ?? ""}</Tooltip>)} placement="bottom">
                                                            <label className="parent-email">
                                                                <b>Email</b>: {el?.emergencyContact?.ecEmail ?? ""}
                                                            </label>
                                                        </OverlayTrigger>
                                                        <br />
                                                        <label htmlFor="">
                                                            <b>Phone Number</b>: {el?.emergencyContact?.ecMobile ?? ""}
                                                        </label>
                                                    </>
                                                ) : (
                                                    <>
                                                        <OverlayTrigger delay={{ hide: 450, show: 300 }} overlay={(props) => (<Tooltip {...props}>{el?.lead?.ecEmail ?? ""}</Tooltip>)} placement="bottom">
                                                            <label className="parent-email">
                                                                <b>Email</b>: {el?.lead?.ecEmail ?? ""}
                                                            </label>
                                                        </OverlayTrigger>
                                                        <br />
                                                        <label htmlFor="">
                                                            <b>Phone Number</b>: {el?.lead?.ecMobile ?? ""}
                                                        </label>
                                                    </>
                                                )}
                                            </td>
                                        </tr>
                                    </>
                                );
                            })
                        ) : (
                            <tr className="no-bg">
                                <td className="text-error text-center">No Patients Matched</td>
                            </tr>
                        ) : (
                            <>
                                <LoaderSkeleton />
                            </>
                        )}
                    </tbody>
                </table>
            </div>
            {(tableData && !loading && isPagination) ? (
                <Pagination
                    dataLength={dataLength}
                    page_number={page}
                    page_size={rowsPerPage}
                    setpage_number={setPage}
                />
            ) : ""}
        </>
    );
}
